import { ExpertCardItemsType } from "components/LSRevamp/LSRevampInterfaces";
export const cardWithImageItems: ExpertCardItemsType[] = [
  {
    image: `${process.env.CDN_URL}/assets/images/LSRevamp/counsellor-1.png`,
    linkedinAddress: "",
    personName: "Salma",
    numberOfStudents: 3500,
    yearsOfExperience: 4,
    content:
      "students counselled. Ensures the right college fit for her students.",
    withExpertise: false,
    gradientColors: {
      from: "from-[#FFF3E0]",
      to: "to-[#EDEFFE]",
    },
  },
  {
    image: `${process.env.CDN_URL}/assets/images/LSRevamp/counsellor-2.png`,
    linkedinAddress: "",
    personName: "Aakriti Jain",
    numberOfStudents: 4000,
    yearsOfExperience: 10,
    content:
      "students counselled. Ensures the right college fit for her students.",
    withExpertise: false,
    gradientColors: {
      from: "from-[#FFF2FA]",
      to: "to-[#C3C9FE]",
    },
  },
  {
    image: `${process.env.CDN_URL}/assets/images/LSRevamp/counsellor-3.png`,
    linkedinAddress: "",
    personName: "Soumita Sen",
    numberOfStudents: 550,
    yearsOfExperience: 10,
    content:
      "students counselled. Ensures the right college fit for her students.",
    withExpertise: false,
    gradientColors: {
      from: "from-[#E5E5F6]",
      to: "to-[#FFFDEC]",
    },
  },
  {
    image: `${process.env.CDN_URL}/assets/images/LSRevamp/counsellor-4.png`,
    linkedinAddress: "",
    personName: "Samiran Roy",
    numberOfStudents: 2600,
    yearsOfExperience: 3,
    content:
      "students counselled. Ensures the right college fit for her students.",
    withExpertise: false,
    gradientColors: {
      from: "from-[#E4F5FF]",
      to: "to-[#D7DBFF]",
    },
  },
  {
    image: `${process.env.CDN_URL}/assets/images/LSRevamp/counsellor-5.png`,
    linkedinAddress: "",
    personName: "Radhika Gupta",
    numberOfStudents: 5000,
    yearsOfExperience: 10,
    content:
      "students counselled. Ensures the right college fit for her students.",
    withExpertise: false,
    gradientColors: {
      from: "from-[#FFF4D7]",
      to: "to-[#E8D7FF]",
    },
  },
  {
    image: `${process.env.CDN_URL}/assets/images/LSRevamp/counsellor-6.png`,
    linkedinAddress: "",
    personName: "Anamika Sharmai",
    numberOfStudents: 5700,
    yearsOfExperience: 12,
    content:
      "students counselled. Ensures the right college fit for her students.",
    withExpertise: false,
    gradientColors: {
      from: "from-[#D7ECFF]",
      to: "to-[#FCFFD7]",
    },
  },
];
